import { Link as RouterLink } from "react-router-dom";
import { darken, List, ListItemButton, ListItemText } from "@mui/material";
import { ArrowForwardIos, House } from "@mui/icons-material";
import { Checklist } from "models/Checklist";
import { useOrderContext } from "context/OrderContext";

type ChecklistsListProps = { checklists: Checklist[] };

const ChecklistsList: React.FC<ChecklistsListProps> = (props) => {
  const { checklists } = props;
  const order = useOrderContext();

  return (
    <List disablePadding sx={{ display: "grid", gap: 1 }}>
      {checklists.map((checklist) => {
        const isDone = checklist.functionCheck && checklist.documentationDone;

        return (
          <ListItemButton
            key={checklist.id}
            component={RouterLink}
            to={`/orders/view/${order.ordernr}/checklist/${checklist.id}`}
            sx={(theme) => ({
              display: "grid",
              gridTemplateColumns: "auto 1fr auto",
              alignItems: "center",
              gap: 2,
              p: 1,
              border: `1px solid`,
              borderColor: theme.palette.grey[400],
              borderRadius: 1,
              ...(checklist.excludedFromReport && {
                opacity: 0.33,
                backgroundColor: "background.disabled",
              }),
              ...(isDone && {
                backgroundColor: "background.success",
                "&:hover": {
                  backgroundColor: "background.success",
                },
                "& .MuiTouchRipple-child": {
                  backgroundColor: darken(theme.palette.background.success, 0.8),
                },
              }),
            })}
          >
            <House
              color={isDone ? "success" : "disabled"}
              sx={{
                fontSize: "2rem",
              }}
            />
            <ListItemText primary={checklist.roomName} secondary={checklist.creator.userName} />
            <ArrowForwardIos sx={{ fontSize: "1.5rem" }} color="disabled" />
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default ChecklistsList;
